/**
 * Ottiene l'IP address del client usando un servizio esterno
 * Usato per audit GDPR nei consent_logs
 * 
 * @returns Promise con l'indirizzo IP o null se non disponibile
 */
export async function getClientIP(): Promise<string | null> {
  try {
    const response = await fetch('https://api.ipify.org?format=json', {
      signal: AbortSignal.timeout(3000) // 3s timeout
    });
    const data = await response.json();
    return data?.ip || null;
  } catch {
    return null;
  }
}
